import React, { useState, useEffect } from 'react';
import { EmailLogin } from './EmailLogin';
import { GoogleLoginButton } from './GoogleLoginButton';
import { colors } from '../../styles/globalStyles';

const DEFAULT_LOGIN = {
  background_inicio: '#f0fdf4',
  background_fim: '#dcfce7'
};

const DEFAULT_CABECALHO = {
  titulo: 'Allma Pilates',
  icone: '🤸‍♀️',
  subtitulo: 'Sistema de Agendamento Inteligente'
};

const DEFAULT_LOGIN_CARD = {
  titulo: 'Acessar minha conta',
  descricao: 'Plataforma online de agendamento de aulas de Pilates. Consulte os horários disponíveis, reserve sua vaga, gerencie e cancele agendamentos — tudo pelo celular ou computador.'
};

const DEFAULT_HEADER = { admin_header_inicio: '#19981b', admin_header_fim: '#106311' };

export const LoginScreen = ({ onSuccess, error }) => {
  const [activeTab, setActiveTab] = useState('google');
  const [loginCfg, setLoginCfg]   = useState(DEFAULT_LOGIN);
  const [cabecalho, setCabecalho] = useState(DEFAULT_CABECALHO);
  const [loginCard, setLoginCard] = useState(DEFAULT_LOGIN_CARD);
  const [headerCores, setHeaderCores] = useState(DEFAULT_HEADER);

  useEffect(() => {
    fetch('/api/site/configuracoes')
      .then(r => r.json())
      .then(data => {
        const cfg = data.configuracoes || {};
        if (cfg.login)    setLoginCfg(c => ({ ...c, ...cfg.login }));
        if (cfg.cabecalho) setCabecalho(c => ({ ...c, ...cfg.cabecalho }));
        if (cfg.login)    setLoginCard(c => ({ ...c, titulo: cfg.login.titulo || c.titulo, descricao: cfg.login.descricao || c.descricao }));
        if (cfg.cores)    setHeaderCores(c => ({ ...c, admin_header_inicio: cfg.cores.admin_header_inicio || c.admin_header_inicio, admin_header_fim: cfg.cores.admin_header_fim || c.admin_header_fim }));
      })
      .catch(() => {});
  }, []);

  const headerGrad = `linear-gradient(135deg, ${headerCores.admin_header_inicio} 0%, ${headerCores.admin_header_fim} 100%)`;

  return (
    <div style={{
      minHeight: '100vh',
      background: `linear-gradient(160deg, ${loginCfg.background_inicio} 0%, ${loginCfg.background_fim} 60%, ${loginCfg.background_fim}cc 100%)`,
      fontFamily: "'Inter', -apple-system, sans-serif",
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '2rem 1rem'
    }}>

      {/* Logo + Nome + Descrição */}
      <div style={{ textAlign: 'center', marginBottom: '1.5rem', maxWidth: 400 }}>
        <div style={{ fontSize: '2.8rem', lineHeight: 1 }}>{cabecalho.icone}</div>
        <h1 style={{ fontSize: '1.75rem', fontWeight: 800, color: '#166534', margin: '0.4rem 0 0.5rem', letterSpacing: '-0.5px' }}>
          {cabecalho.titulo}
        </h1>
        <p style={{ color: '#374151', fontSize: '0.9rem', margin: 0, lineHeight: 1.6 }}>
          {loginCard.descricao}
        </p>
      </div>

      {/* Login Card */}
      <div style={{ backgroundColor: 'white', borderRadius: 20, boxShadow: '0 8px 32px rgba(0,0,0,0.10)', width: '100%', maxWidth: 400, overflow: 'hidden' }}>
        <div style={{ background: headerGrad, padding: '1.25rem 1.5rem', textAlign: 'center', color: 'white' }}>
          <h2 style={{ margin: 0, fontSize: '1rem', fontWeight: 600 }}>{loginCard.titulo}</h2>
        </div>

        <div style={{ padding: '1.5rem' }}>
          <div style={{ display: 'flex', backgroundColor: '#f1f5f9', borderRadius: 10, padding: '0.2rem', marginBottom: '1.25rem' }}>
            {[{ key: 'google', label: '🔐 Google' }, { key: 'email', label: '📧 E-mail' }].map(tab => (
              <button key={tab.key} onClick={() => setActiveTab(tab.key)} style={{
                flex: 1, padding: '0.55rem', border: 'none',
                backgroundColor: activeTab === tab.key ? 'white' : 'transparent',
                borderRadius: 8, fontSize: '0.85rem', fontWeight: 600,
                color: activeTab === tab.key ? headerCores.admin_header_inicio : colors.gray,
                cursor: 'pointer', transition: 'all 0.2s',
                boxShadow: activeTab === tab.key ? '0 1px 4px rgba(0,0,0,0.08)' : 'none'
              }}>{tab.label}</button>
            ))}
          </div>

          {error && (
            <div style={{ backgroundColor: '#fee2e2', color: '#991b1b', padding: '0.75rem 1rem', borderRadius: 8, marginBottom: '1rem', fontSize: '0.85rem', display: 'flex', gap: '0.5rem', alignItems: 'flex-start' }}>
              <span>⚠️</span> {error}
            </div>
          )}

          <div style={{ minHeight: 120 }}>
            {activeTab === 'google' ? (
              <div>
                <p style={{ color: colors.gray, fontSize: '0.82rem', textAlign: 'center', margin: '0 0 1rem' }}>
                  Use sua conta Google para entrar
                </p>
                <GoogleLoginButton onSuccess={onSuccess} />
              </div>
            ) : (
              <EmailLogin onSuccess={onSuccess} />
            )}
          </div>

          <p style={{ color: '#94a3b8', fontSize: '0.75rem', textAlign: 'center', margin: '1rem 0 0' }}>
            Não tem conta? Fale com a administração.
          </p>
        </div>
      </div>

      {/* Funcionalidades */}
      <div style={{ width: '100%', maxWidth: 400, marginTop: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
        {[
          { icon: '📅', text: 'Veja a grade semanal de horários disponíveis' },
          { icon: '✅', text: 'Reserve sua vaga em segundos, de qualquer lugar' },
          { icon: '🔔', text: 'Confirmação imediata por e-mail' },
          { icon: '📆', text: 'Agendamentos sincronizados com o Google Agenda' },
        ].map(f => (
          <div key={f.text} style={{ background: 'white', borderRadius: 12, padding: '0.75rem 1rem', display: 'flex', alignItems: 'center', gap: '0.75rem', boxShadow: '0 1px 6px rgba(0,0,0,0.05)', border: `1px solid ${loginCfg.background_fim}` }}>
            <span style={{ fontSize: '1.3rem', flexShrink: 0 }}>{f.icon}</span>
            <span style={{ fontSize: '0.83rem', color: '#374151', lineHeight: 1.4 }}>{f.text}</span>
          </div>
        ))}
      </div>

      <footer style={{ marginTop: '1.75rem', textAlign: 'center', fontSize: '0.75rem', color: '#9ca3af' }}>
        <p style={{ margin: '0 0 0.4rem' }}>© {new Date().getFullYear()} {cabecalho.titulo}</p>
        <p style={{ margin: 0 }}>
          <a href="/privacidade.html" target="_blank" rel="noopener noreferrer" style={{ color: headerCores.admin_header_inicio, textDecoration: 'none' }}>Política de Privacidade</a>
          {' · '}
          <a href="/termos.html" target="_blank" rel="noopener noreferrer" style={{ color: headerCores.admin_header_inicio, textDecoration: 'none' }}>Termos de Serviço</a>
          {' · '}
          <a href="mailto:allmapilates@gmail.com" style={{ color: headerCores.admin_header_inicio, textDecoration: 'none' }}>Contato</a>
        </p>
      </footer>
    </div>
  );
};
